import { Component, OnInit } from '@angular/core';
import { DocAffected } from '../../../../../models';
import { DocumentGeneric } from '../../../../../models/document/document.model';
import { StageService } from '../../services/stage-modal.service';
import { MailService } from '../mail.service'

@Component({
  selector: 'queoval-mail-step-two',
  templateUrl: './mail-two.component.html',
  styleUrls: ['./mail-two.component.css']
})
  /*
* Composant pour la sélection des documents (Etape 2)
*/
export class MailTwoComponent implements OnInit {

  //#region Constructeur
  constructor(
    public service: StageService,
    public mailService: MailService,
  ) { }
  //#endregion Constructeur

  //#region Cycle de vie
  ngOnInit(): void {
 
  }
  //#endregion Cycle de vie

  /**
   * Mise à jour de la liste des documents
   * @param doc document envoyé par le composant (doc coché)
   */
  public UpdateListDoc(doc: DocumentGeneric): void {
    if (doc.IsSelected) {

      if (this.mailService.modelMail.ListDocAffected.findIndex((docAff: DocAffected) => docAff.Ident == doc.Ident) == -1) {
        // Ajout d'un nouveau document à la liste
        let newDoc: DocAffected = new DocAffected();
        newDoc.Ident = doc.Ident;
        newDoc.Value = doc.Title;
        newDoc.Code = doc.Code;
        newDoc.TypeDocAffected = doc.TypeDoc;
        this.mailService.modelMail.ListDocAffected.push(newDoc);
      }
      this.mailService.modelMail = JSON.parse(JSON.stringify(this.mailService.modelMail));

      if (!this.mailService.lstDocumentsSelected.includes(doc.Ident)) {
        this.mailService.lstDocumentsSelected.push(doc.Ident)
      }
            
    }
    else {
      // Retrait du document (par rapport à l'ident)
      const positionDocAff:number = this.mailService.modelMail.ListDocAffected.findIndex(recip => recip.Ident == doc.Ident)
      if (positionDocAff != -1)
        this.mailService.modelMail.ListDocAffected.splice(positionDocAff, 1);
      this.mailService.modelMail = JSON.parse(JSON.stringify(this.mailService.modelMail));

      const positionDocSel: number = this.mailService.lstDocumentsSelected.findIndex(ident => ident === doc.Ident)
      if (positionDocSel != -1)
        this.mailService.lstDocumentsSelected.splice(positionDocSel, 1);
    }
  }
  //#endregion Fonctions Publics
}
